const STORAGE_KEY = 'content4life_recommended_plan';
const SHOW_MODAL_KEY = 'content4life_show_plan_modal';

export function getRecommendedPlan(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function setRecommendedPlan(plan: string): void {
  sessionStorage.setItem(STORAGE_KEY, plan);
}

export function clearRecommendedPlan(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

// Flag para indicar que o modal de planos deve ser mostrado
export function shouldShowPlanModal(): boolean {
  return sessionStorage.getItem(SHOW_MODAL_KEY) === 'true';
}

export function setShowPlanModal(show: boolean): void {
  if (show) {
    sessionStorage.setItem(SHOW_MODAL_KEY, 'true');
  } else {
    sessionStorage.removeItem(SHOW_MODAL_KEY);
  }
}

export function clearShowPlanModal(): void {
  sessionStorage.removeItem(SHOW_MODAL_KEY);
}
